import * as React from 'react';

import {ChatPageContainer} from './containers';

export const ChatPage: React.FC = () => {
    return (
        <ChatPageContainer />
    );
};
